// D:\my-website\src\components\ContactUsPage.js

import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
// 假设您的 firebase 配置文件在 src/firebase.js
import { db } from '../firebase'; // 引入 Firebase Firestore 实例
import { collection, addDoc } from 'firebase/firestore'; // 引入 Firestore 写入数据的函数

function ContactUsPage({ contactInfo }) { // 注意：这里使用了 ContactUsPage 对应您的文件名
  const { t } = useTranslation();

  const info = contactInfo || {}; // 确保 contactInfo 存在，否则使用空对象

  // 留言表单的状态
  const [name, setName] = useState('');
  const [email, setEmail] = useState('');
  const [message, setMessage] = useState('');
  const [status, setStatus] = useState(''); // 用于显示提交状态和反馈信息

  // 处理表单提交的函数
  const handleSubmit = async (e) => {
    e.preventDefault(); // 阻止表单默认提交行为，避免页面刷新

    setStatus(t('form_submitting')); // 设置提交状态提示 (例如: "正在提交...")

    try {
      // 使用 addDoc 将留言数据添加到 Firestore 中名为 'messages' 的集合里
      await addDoc(collection(db, 'messages'), {
        name: name,
        email: email,
        message: message,
        timestamp: new Date() // 记录留言的提交时间
      });
      setStatus(t('form_success_message')); // 提交成功提示 (例如: "留言成功，感谢您的反馈！")
      // 提交成功后清空表单字段
      setName('');
      setEmail('');
      setMessage('');
    } catch (error) {
      console.error("提交留言失败: ", error); // 在控制台打印错误信息
      setStatus(t('form_error_message')); // 提交失败提示 (例如: "提交失败，请稍后再试。")
    }
  };

  return (
    <section id="contact" className="py-16 md:py-24 bg-white rounded-lg shadow-md m-4">
      <div className="container mx-auto px-4 md:px-6">
        <h2 className="text-3xl md:text-4xl font-bold text-gray-800 mb-10 section-title">{t('contact_us')}</h2>

        {/* 新增的留言板块 - 现在放在前面 */}
        <div className="bg-white p-8 rounded-lg shadow-lg max-w-2xl mx-auto mb-12"> {/* 添加 mb-12 以与下方联系信息保持间距 */}
          <h2 className="text-2xl md:text-3xl font-bold text-gray-800 mb-8">{t('leave_a_message_title')}</h2> {/* 留言板块标题，可国际化 */}
          <form onSubmit={handleSubmit} className="space-y-6 text-left">
            <div>
              <label htmlFor="name" className="block text-gray-700 text-base font-semibold mb-2">
                {t('form_name_label')}:
              </label>
              <input
                type="text"
                id="name"
                value={name}
                onChange={(e) => setName(e.target.value)}
                required
                placeholder={t('form_name_placeholder')}
                className="shadow-sm appearance-none border rounded w-full py-3 px-4 text-gray-700 leading-tight focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent transition duration-200"
              />
            </div>

            <div>
              <label htmlFor="email" className="block text-gray-700 text-base font-semibold mb-2">
                {t('form_email_label')}:
              </label>
              <input
                type="email"
                id="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                required
                placeholder={t('form_email_placeholder')}
                className="shadow-sm appearance-none border rounded w-full py-3 px-4 text-gray-700 leading-tight focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent transition duration-200"
              />
            </div>

            <div>
              <label htmlFor="message" className="block text-gray-700 text-base font-semibold mb-2">
                {t('form_message_label')}:
              </label>
              <textarea
                id="message"
                value={message}
                onChange={(e) => setMessage(e.target.value)}
                rows="6"
                required
                placeholder={t('form_message_placeholder')}
                className="shadow-sm appearance-none border rounded w-full py-3 px-4 text-gray-700 leading-tight focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent transition duration-200 resize-y"
              ></textarea>
            </div>

            <button
              type="submit"
              className="w-full bg-blue-600 hover:bg-blue-700 text-white font-bold py-3 px-4 rounded-lg focus:outline-none focus:shadow-outline transition duration-300 transform hover:scale-105"
            >
              {t('form_submit_button')}
            </button>

            {/* 提交状态和反馈信息，根据状态动态改变样式和文本 */}
            {status && (
              <p className={`mt-4 text-center text-lg font-semibold ${status.includes(t('form_success_keyword')) ? 'text-green-600' : status.includes(t('form_error_keyword')) ? 'text-red-600' : 'text-blue-600'}`}>
                {status}
              </p>
            )}
          </form>
        </div>

        {/* 现有联系信息部分 - 现在放在后面 */}
        <div className="bg-gray-50 p-8 rounded-lg shadow-lg max-w-2xl mx-auto">
          <div className="space-y-4 text-lg text-gray-700">
            <p>
              <strong>{t('contact_phone_label')}:</strong> {info.phone}
            </p>
            <p>
              <strong>{t('contact_email_label')}:</strong> {info.email}
            </p>
            <p>
              <strong>{t('contact_address_label')}:</strong> {info.address}
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}

export default ContactUsPage;
